import React from 'react'

import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast'
import { Button } from 'primereact/button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import NavBar from '../../componentes/Navbar'
import ProcessoService from '../../app/service/ProcessoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import warning from '../../img/warning3.jpg'

class ProcessosExcluidos extends React.Component {
  constructor(props) {
    super(props);

    this.processoService = new ProcessoService();

    this.aceptAtivarProcesso = this.aceptAtivarProcesso.bind(this);
    this.acoes = this.acoes.bind(this);
    this.renderFooterAvisoExclusao = this.renderFooterAvisoExclusao.bind(this);

    this.state = {
      detail: '',
      processos: [],
      codigo: '',
      openSpinner: false,
      modalAvisoDefinitivo: false,
      codigoProcessoExcluir: '',
    }
  }

  consultarProcessosExcluidos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.processoService.consultarProcessosExcluidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({processos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Excluídos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-history" className="p-button-rounded p-button-text" 
                onClick={() => this.confirmacaoAtivacaoProcesso(rowData)}
                tooltip="Retornar a Ativo" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Processo"
                onClick={() => this.avisoExclusao(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  avisoExclusao = (processo) => {
    this.setState({codigoProcessoExcluir: processo.processo.codigo});
    this.abrirModal('modalAvisoDefinitivo');
  }

  renderFooterAvisoExclusao(name) {
    return (
        <div>
            <Button label="Confirmar" 
                    className="p-button-primary p-button-text"
                    onClick={this.excluirDefinitivamente}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  excluirDefinitivamente = async () => {
    this.setState({openSpinner: true});
    await this.processoService.excluirDefinitivamente(this.state.codigoProcessoExcluir)
      .then(response => {
        this.consultarProcessosExcluidos();
        this.toast.show({severity:'success', summary: 'Excluaão de Processo', detail:'Processo excluído com sucesso', life: 4000});
        this.fecharModal('modalAvisoDefinitivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Excluaão de Processo', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  confirmacaoAtivacaoProcesso(processo) {
    this.setState({codigo: processo.processo.codigo});
    confirmDialog({
        message: 'Deseja realmente ativar o processo selecionado?',
        header: 'Ativação de Processo',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.aceptAtivarProcesso,
        reject: this.reject
    });
  }

  async ativarProcesso() {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    const processo = {
      codigo: this.state.codigo,
      status: 0,
      usuario: usuarioLogado.codigo
    }

    await this.processoService.ativarProcesso(processo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Processos Excluídos', detail:'Processo ativado com sucesso!', life: 4000});
        this.consultarProcessosExcluidos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Excluído', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  aceptAtivarProcesso() {
    this.ativarProcesso();
  }
  
  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.consultarProcessosExcluidos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-times-circle"></i>
                        <span> Processos Excluidos</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <DataTable value={this.state.processos}  paginator responsiveLayout="scroll" 
                                 emptyMessage="Nenhum processo excluído"
                                 size="small"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                        <Column field="processo.codigo" header="Código Processo"></Column>
                        <Column field="processo.nrCnj" header="Número CNJ"></Column>
                        <Column field="processo.nrProcesso" header="Número Processo"></Column>
                        <Column field="processo.pasta" header="Pasta"></Column>
                        <Column field="processo.grupoTrabalho.nome" header="Grupo de Trabalho"></Column>
                        <Column field="dataExcluido" header="Data de Exclusão"></Column>
                        <Column field="usuario.nome" header="Usuário Excluiu"></Column>
                        <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
                <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={this.state.openSpinner}>
                  <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                </Backdrop>
                {/**Avisio de exclusão em definitivo */}
                <Dialog header="Exclusão de Processo"
                                  visible={this.state.modalAvisoDefinitivo} 
                                  style={{ width: '30vw' }} 
                                  footer={this.renderFooterAvisoExclusao('modalAvisoDefinitivo')}
                                  onHide={() => this.fecharModal('modalAvisoDefinitivo')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <div style={{textAlign: 'center', justifyContent: 'center', alignItems: 'center'}}>
                              <img src={warning} alt="iLaw Gestão" style={{width: '20%'}} />
                            </div>
                            <br></br>
                            <p>
                              <h5>
                              Ao optar por excluir em definitivo, além do processo, todas as atividades, históricos,
                              lancamentos financeiros, pagamentos e custas serão excluídos também.
                              Esta ação é irreversível, confirma a exlusão mesmo assim ?</h5>
                            </p>
                          </div>
                        </div>
                      </div>
                </Dialog>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
  }

ProcessosExcluidos.contextType = AuthContext;
export default withRouter(ProcessosExcluidos)